import { BehaviorSubject } from 'rxjs';
import { httpGet } from './http-utils';
import { returnResponseIfOkOrSetGlobalErrorMessage } from './api-utils';
import { setGlobalErrorMessage } from './app-global-values';

export const getAllTenantIds = () => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet('tsi-multit/tenants/ids'),
    'Failed to get the list of all tenant ids',
    '',
    true
  );
};

export const tenantAwsAccountsSubject$ = new BehaviorSubject(null);
export const refreshTenantAwsAccounts = tenantId => {
  httpGet(`tsi-multit/tenants/${tenantId}/tenant-resources/aws-accounts`)
    .then(response => {
      const awsAccountIds = response.data.map(resource => resource.resourceData);
      tenantAwsAccountsSubject$.next(awsAccountIds);
    })
    .catch(err => setGlobalErrorMessage(`Error while retrieving tenant aws accounts: ${err}`));
};

export const getTenantMetaData = tenantId => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}`),
    `Failed to get tenant metadata for ${tenantId}.`,
    '',
    true
  );
};
